import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-foreground-950 border-b border-white/10">
      <div className="px-4 md:px-10 py-3 md:py-3.5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <span className="font-heading text-lg md:text-xl font-bold text-white tracking-tight">
            CSSBuy <span className="text-accent-400">Spreadsheet</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-4">
          <Link to="/" className="text-white/90 hover:text-white text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer">
            Home
          </Link>

          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center gap-2 px-4 py-2 rounded-full border border-white/20 bg-white/5 text-white/90 hover:border-accent-400 hover:text-white transition-colors text-sm font-medium cursor-pointer whitespace-nowrap"
            >
              <i className="ri-grid-line"></i>
              Guia de Compras
              <i className={`ri-arrow-down-s-line transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {dropdownOpen && (
              <div className="absolute top-full mt-2 right-0 w-64 bg-foreground-900 border border-white/10 rounded-xl overflow-hidden max-h-80 overflow-y-auto z-50">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-4 py-3 text-sm text-white/80 hover:bg-white/10 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className={`${cat.icon} text-accent-400 w-5 h-5 flex items-center justify-center`}></i>
                    {cat.name}
                  </a>
                ))}
              </div>
            )}
          </div>

          <Link to="/cssbuy-spreadsheet-2026" className="text-white/80 hover:text-white text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
            Guia 2026
          </Link>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-5 py-2.5 rounded-full bg-primary-500 text-white hover:bg-primary-400 transition-all text-sm font-bold cursor-pointer whitespace-nowrap"
          >
            cssbuy spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-5 py-2.5 rounded-full border-2 border-accent-400 text-accent-400 hover:bg-accent-400 hover:text-foreground-950 transition-all text-sm font-bold cursor-pointer whitespace-nowrap"
          >
            BUY IT NOW
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-white"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-foreground-900 border-t border-white/10 px-4 py-4 flex flex-col gap-2 max-h-[70vh] overflow-y-auto">
          <Link to="/" onClick={() => setMobileOpen(false)} className="text-white/90 text-sm font-semibold py-2.5 cursor-pointer border-b border-white/5">
            <i className="ri-home-4-line mr-2"></i>Home
          </Link>

          <button
            onClick={() => setMobileCatOpen(!mobileCatOpen)}
            className="flex items-center justify-between w-full text-white/90 text-sm font-semibold py-2.5 cursor-pointer border-b border-white/5"
          >
            <span><i className="ri-shopping-bag-3-line mr-2"></i>Guia de Compras</span>
            <i className={`ri-arrow-down-s-line transition-transform ${mobileCatOpen ? 'rotate-180' : ''}`}></i>
          </button>

          {mobileCatOpen && (
            <div className="pl-4 flex flex-col gap-0.5 border-b border-white/5 pb-2">
              {categories.map((cat) => (
                <a key={cat.name} href={cat.url} target="_blank" rel="noopener nofollow" className="flex items-center gap-2 py-2 text-sm text-white/70 hover:text-accent-300 cursor-pointer whitespace-nowrap">
                  <i className={`${cat.icon} text-accent-400 w-4 h-4 flex items-center justify-center`}></i>
                  {cat.name}
                </a>
              ))}
            </div>
          )}

          <Link to="/cssbuy-spreadsheet-2026" onClick={() => setMobileOpen(false)} className="text-white/90 text-sm font-medium py-2.5 cursor-pointer border-b border-white/5">
            <i className="ri-article-line mr-2"></i>Guia 2026
          </Link>

          <div className="flex flex-col gap-2 pt-2">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="w-full text-center px-5 py-3 rounded-full bg-primary-500 text-white hover:bg-primary-400 transition-all text-sm font-bold cursor-pointer whitespace-nowrap"
            >
              cssbuy spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="w-full text-center px-5 py-3 rounded-full border-2 border-accent-400 text-accent-400 hover:bg-accent-400 hover:text-foreground-950 transition-all text-sm font-bold cursor-pointer whitespace-nowrap"
            >
              BUY IT NOW
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}